import { useState } from 'react';
import type { FormEvent } from 'react';
import { useTracking } from 'react-tracking';

import { Modal, Textfield } from '@simplywallst/ui-core';

import type { Watchlist } from '@/hooks/useWatchlist';
import useWatchlistMutations from '../../hooks/useWatchlistMutations';

interface Props {
  onClose: () => void;
  onRename?: () => void;
  watchlist: Watchlist;
}

const RenameWatchlistModal = ({ onClose, onRename, watchlist }: Props) => {
  const [watchlistName, setNewWatchlistName] = useState(watchlist.name);
  const [nameLengthError, setNameLengthError] = useState(false);

  const { trackEvent } = useTracking();
  const { renameWatchlist } = useWatchlistMutations();

  const handleRename = () => {
    trackEvent({
      action: 'click',
      modifier: 'renameWatchlist',
    });
    renameWatchlist({
      id: watchlist.id,
      newName: watchlistName,
    });
    onRename && onRename();
  };

  return (
    <Modal
      title="Rename List"
      asForm={true}
      onSecondaryClick={onClose}
      onPrimaryClick={handleRename}
      secondaryLabel="Cancel"
      primaryLabel="Save"
      primaryDisabled={nameLengthError}
    >
      <Textfield
        name="listName"
        styleType="standardReverse"
        type="text"
        label="List Name"
        value={watchlistName}
        onChange={(e: FormEvent<HTMLInputElement>) => {
          setNewWatchlistName(e.currentTarget.value);
          setNameLengthError(e.currentTarget.value.length === 0);
        }}
        error={nameLengthError ? 'Name cannot be blank' : ''}
      />
    </Modal>
  );
};

export default RenameWatchlistModal;
